import React from 'react';

import { type MenuProps } from '@atlaskit/select';

import { type SingleOption } from '../../../../common/types';

export const Menu = ({
	innerRef,
	innerProps,
	children,
}: MenuProps<SingleOption, true>): React.JSX.Element => (
	<div data-testid="refinement-bar.common.ui.select.menu" ref={innerRef} {...innerProps}>
		{children}
	</div>
);
